import React from "react";

import { Alert, Skeleton } from "@mui/material";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";

import useLazyLoad, { LazyState } from "../shared/LazyLoad";

type StatsColumnProps = {
  title: string;
  getStats: () => Promise<{ label: string; value: string }[]>;
};

const StatsColumn: React.FC<StatsColumnProps> = ({ title, getStats }) => {
  const { state, data: stats, error } = useLazyLoad(getStats);

  const renderContent = () => {
    switch (state) {
      case LazyState.Loaded:
        return stats!.map(({ label, value }) => (
          <TableRow key={label}>
            <TableCell>{label}</TableCell>
            <TableCell align="right">{value}</TableCell>
          </TableRow>
        ));
      case LazyState.Error:
        return (
          <TableRow>
            <TableCell colSpan={2}>
              <Alert severity="error">{error?.message || "Unknown error"}</Alert>
            </TableCell>
          </TableRow>
        );
      default:
        return (
          <TableRow>
            <TableCell colSpan={2}>
              <Skeleton />
            </TableCell>
          </TableRow>
        );
    }
  };

  return (
    <>
      <Typography sx={{ fontSize: "14pt", pb: "8px" }}>{title}</Typography>
      <TableContainer component={Paper}>
        <Table aria-busy={state === LazyState.Loading} aria-label={title}>
          <TableBody>{renderContent()}</TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

export default StatsColumn;
